import React, { FC } from 'react';
import Image from 'next/image';

interface ConsultationProps {
  titleText: string;
  description: string;
  pcImages: string[];
  h5Images: string[];
}

const ConsultationModule: FC<ConsultationProps> = ({ titleText, description, pcImages, h5Images }) => {
  return (
    <section className="mx-5 pt-[42px] md:pt-[60px] lg:max-w-screen-xl l:mx-auto">
      <h2 className="text-[18px] font-medium md:text-[28px]">{titleText}</h2>

      <p className="pt-[11px] text-justify text-[12px] text-[rgba(0,0,0,0.6)] opacity-75 md:pt-[8px] md:text-[16px] md:text-base md:text-[#111]">
        {description}
      </p>

      <div className="pt-[20px]">
        <div className="hidden md:block md:space-y-5">
          {pcImages.map((imgSrc) => (
            <div key={imgSrc} className="relative max-h-[560px] w-full overflow-hidden rounded-2xl text-[0]">
              <Image src={imgSrc} width={1280} height={560} alt="pc-img" />
            </div>
          ))}
        </div>
        <div className="space-y-1 md:hidden ">
          {h5Images.map((imgSrc) => (
            <div key={imgSrc} className="relative max-h-[1200px] w-full overflow-hidden rounded-lg text-[0]">
              <Image src={imgSrc} width={750} height={1200} alt="h5-img" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ConsultationModule;
